import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'om-select-icon',
  templateUrl: './om-select-icon.component.html',
  styleUrls: ['./om-select-icon.component.scss']
})
export class OmSelectIconComponent implements OnInit {

  @Input() control: FormControl;
  @Input() disabled: boolean = false;
  @Input() mode: 'multiple' | 'tags' | 'default' = 'default';
  @Input() clear: boolean = false;
  
  @Input() label: string;
  @Input() icon: string;

  @Input() options: any[];
  @Input() valueName: string = 'value';
  @Input() labelName: string = 'label';

  isRequired$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
    this.isRequired$.next(this.control.hasValidator(Validators.required))
  }
}
